import { useEffect } from "react"

export const RedirectPage = () => {
    useEffect(() => {
        window.location.replace("https://kriya.co/")
    }, [])
    return null
}